<script lang="ts">
      import Window from '$lib/components/gallery/Window.svelte'
      import { setRollover } from '$lib/utils/array'
      import { onMount, untrack } from 'svelte'
      import VideoElement from '../video/VideoElement.svelte'
      import ImageElement from './ImageElement.svelte'

      let move = 0
      let shouldMove = true

      async function onmove(deltaX, deltaY, position) {

            const multiply = deltaX + deltaY/4 >= 1 ? 1 : -1
            const hypotDelta = Math.hypot(deltaX, deltaY/4)
            
            move += hypotDelta * multiply

            if (shouldMove == false) return

            let width = document.body.offsetWidth / 6
            if (width > 300) width = 300

            if (move > width) {
                  changeItem(-1)
                  move = 0
                  shouldMove = false
            } else if (move < -1 * width) {
                  changeItem(+1)
                  move = 0
                  shouldMove = false
            }
      }

      async function onend(position) {
            //const width = document.body.offsetWidth / 4
            //if (move > width ) changeItem(-1)
            //else if (move < -1 * width) changeItem(+1)
            move = 0
            shouldMove = true
      }

      async function changeItem(dir: number) {
            selected = setRollover(selected, _blocks.length, dir)
      }

      $effect(() => {
            _blocks
            untrack(() => {
                  selected = Math.floor(_blocks.length / 2)
            })
      })

      onMount(() => {
            selected = 0
      })

      let selected = $state(0)

      let { blocks, fixedAspect = 'none', rowHeight = 'normal' } = $props()

      let bubble = false

      function release() {
            return (bubble = false)
      }

      function selectAsset(this: HTMLElement, ev: Event) {
            if (bubble) return release()
            bubble = true

            const target = this as HTMLElement
            if (!target) return release()

            const _index = this.getAttribute('data-index')
            if (!_index) return release()

            const index = parseInt(_index)
            if (Number.isNaN(index)) return release()

            if (index == selected) return release()

            ev.stopPropagation()

            selected = index
            //bounce off
            setTimeout(() => release(), 300)
      }

      let _blocks = $derived.by(() => {
            const _bl = blocks.map((b) => {
                  return {
                        item: b,
                  }
            })

            const offset = []
            const middle = Math.floor(_bl.length / 2)
            for (let i = 0; i < _bl.length; i++) {
                  const ind = setRollover(i, _bl.length, middle)
                  offset[ind] = _bl[i]
            }

            return offset
      })

      let _height = $derived.by(() => {
            if (rowHeight == 'high') return '64rem'
            if (rowHeight == 'highest') return '48rem'
            return 'auto'
      })
</script>

<div class="w-full mx-auto aspect-[3/2]" style="height: {_height}">
      <Window {selected} {onmove} {onend} class="flex justify-left items-center relative h-full">
            {#each _blocks as block, i (i)}
                  <!-- svelte-ignore a11y_no_static_element_interactions -->
                  <div data-index={i} onmousedown={selectAsset} ontouchstart={selectAsset} class="h-full w-auto carousel-item relative flex justify-center items-center" style="--left: -{10 * i}">
                        {@render CarouselItem(block)}
                  </div>
            {/each}
      </Window>
</div>

{#snippet CarouselItem(block: any)}
      {#if block.item.mimeType.match(/image\/.*/)}
            <ImageElement image={block.item} class="h-full w-max aspect-auto object-contain" elementClass="w-auto h-full"></ImageElement>
      {/if}
      {#if block.item.mimeType.match(/video\/.*/)}
            <VideoElement video={block.item} class="h-full aspect-video object-contain max-w-[97vw]" autoplay={false} cache={false} muted={false}></VideoElement>
      {/if}
{/snippet}

<style lang="postcss">
      .carousel-item {
            @apply opacity-0 scale-[0.91] z-[0] w-full max-w-[99vw];
            /*mix-blend-mode: plus-lighter;*/
            transition: all 0.3s ease-in-out;
            left: calc(var(--left) * 1rem);
            /*filter: brightness(0.3) contrast(0.3);*/
      }

      :global(.carousel-move-motion) .carousel-item {
            @apply opacity-10;
      }

      .carousel-item:global(:has(+ .carousel-item.selected)) {
            @apply opacity-100 z-[9]  scale-[0.96];
            filter: brightness(0.6) contrast(0.6);
      }

      .carousel-item:global(.selected) + .carousel-item {
            filter: brightness(0.6) contrast(0.6);
            @apply opacity-100 z-[9]  scale-[0.96];
      }

      .carousel-item:global(:has(+ .carousel-item + .carousel-item.selected)) {
            @apply opacity-10 z-[5];
      }

      .carousel-item:global(.selected) + .carousel-item + .carousel-item {
            @apply opacity-10 z-[5];
      }

      .carousel-item:global(.selected) {
            @apply opacity-100 scale-100 z-[10];
            mix-blend-mode: normal;
      }

      .carousel-item :global(> *) {
            @apply rounded-2xl contain-paint shadow-md;
      }
</style>
